



















import { Component, Vue, Prop } from 'nuxt-property-decorator';
import WarRoomAvatar from '@/components/partials/war-room/WarRoomAvatar.vue';
import HeaderMenuNotificationsCardGridAvatarTypeIcon from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGridAvatar/HeaderMenuNotificationsCardGridAvatarTypeIcon/HeaderMenuNotificationsCardGridAvatarTypeIcon.vue';
import { notificationTypes } from '@/components/global/HeaderMenu/HeaderMenuNotifications/constants';
import type { Anonymous, Maybe, Notification, Public, TestimonialRequestor, User, UserAuthor } from '@/types/graphql';
import WarRoomLogo from './images/war-room-logo.vue.svg';
import AnonymousActionImage from './images/anonymous-action.vue.svg';

@Component<HeaderMenuNotificationsCardGridAvatar>({
  components: {
    WarRoomAvatar,
    HeaderMenuNotificationsCardGridAvatarTypeIcon,
    WarRoomLogo,
    AnonymousActionImage,
  },
})
export default class HeaderMenuNotificationsCardGridAvatar extends Vue {
  @Prop({ required: true }) notification!: Notification;
  @Prop({ type: Boolean, default: true }) hasTypeIcon!: boolean;
  @Prop({ type: Boolean, default: false }) anonymous!: boolean;

  get user(): User | UserAuthor | TestimonialRequestor | undefined {
    const referenceable = (this.notification as Notification).referenceable;

    if (referenceable) {
      if ('requestor' in referenceable) {
        return referenceable.requestor;
      } else if ('author' in referenceable) {
        return referenceable.author;
      } else {
        return referenceable as User;
      }
    } else {
      return undefined;
    }
  }

  get userAvatar(): Maybe<string> | undefined {
    return (this.user as Public).avatarUrl || (this.user as Anonymous).warRoomAvatarUrl;
  }

  get userTitle(): Maybe<string> | undefined {
    return (this.user as Public).lastname || (this.user as Anonymous).username;
  }

  get shouldShowAvatar(): boolean {
    return ![notificationTypes.OFFICIAL_POST, notificationTypes.MOBILE_APP_POST].includes(this.notification.type);
  }
}
